var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarTotalBlogs = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.0039,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_52537_21487)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17 6H15.5V5.5C15.5 5.36739 15.4473 5.24021 15.3536 5.14645C15.2598 5.05268 15.1326 5 15 5C14.8674 5 14.7402 5.05268 14.6464 5.14645C14.5527 5.24021 14.5 5.36739 14.5 5.5V6H9.5V5.5C9.5 5.36739 9.44732 5.24021 9.35355 5.14645C9.25979 5.05268 9.13261 5 9 5C8.86739 5 8.74021 5.05268 8.64645 5.14645C8.55268 5.24021 8.5 5.36739 8.5 5.5V6H7C6.73478 6 6.48043 6.10536 6.29289 6.29289C6.10536 6.48043 6 6.73478 6 7V17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18H17C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17V7C18 6.73478 17.8946 6.48043 17.7071 6.29289C17.5196 6.10536 17.2652 6 17 6ZM14.6038 12.3538L11.6038 15.3538C11.5573 15.4002 11.5022 15.4371 11.4415 15.4623C11.3808 15.4874 11.3157 15.5004 11.25 15.5004C11.1843 15.5004 11.1192 15.4874 11.0585 15.4623C10.9978 15.4371 10.9427 15.4002 10.8962 15.3538L9.39625 13.8538C9.30243 13.7599 9.24972 13.6327 9.24972 13.5C9.24972 13.3673 9.30243 13.2401 9.39625 13.1462C9.49007 13.0524 9.61732 12.9997 9.75 12.9997C9.88268 12.9997 10.0099 13.0524 10.1038 13.1462L11.25 14.2931L13.8962 11.6462C13.9427 11.5998 13.9979 11.5629 14.0586 11.5378C14.1192 11.5127 14.1843 11.4997 14.25 11.4997C14.3157 11.4997 14.3808 11.5127 14.4414 11.5378C14.5021 11.5629 14.5573 11.5998 14.6038 11.6462C14.6502 11.6927 14.6871 11.7479 14.7122 11.8086C14.7373 11.8692 14.7503 11.9343 14.7503 12C14.7503 12.0657 14.7373 12.1308 14.7122 12.1914C14.6871 12.2521 14.6502 12.3073 14.6038 12.3538ZM7 9V7H8.5V7.5C8.5 7.63261 8.55268 7.75979 8.64645 7.85355C8.74021 7.94732 8.86739 8 9 8C9.13261 8 9.25979 7.94732 9.35355 7.85355C9.44732 7.75979 9.5 7.63261 9.5 7.5V7H14.5V7.5C14.5 7.63261 14.5527 7.75979 14.6464 7.85355C14.7402 7.94732 14.8674 8 15 8C15.1326 8 15.2598 7.94732 15.3536 7.85355C15.4473 7.75979 15.5 7.63261 15.5 7.5V7H17V9H7Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_52537_21487",
  x1: 6.50391,
  y1: 1,
  x2: 16.0039,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1EAED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A0C8FF"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarTotalBlogs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_total_blogs.56ecda76f1aa04598486f2b589380c34.svg";